export const RoleModel = { id: 0, name: "" };
